/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {StubbifyPrivacyRequestRequest} from '@cash-web/protos/squareup/privacyvault/service.pb'
import {StubbifyPrivacyRequestResponse} from '@cash-web/protos/squareup/privacyvault/service.pb'


export const stubbifyPrivacyRequest = (request: StubbifyPrivacyRequestRequest, options?: CashRequestOptions) => post<StubbifyPrivacyRequestRequest, StubbifyPrivacyRequestResponse>("/2.0/cash/stubbify-privacy-request", request, {...options, rejectOnError: true })